import Invoice1Container from "../../../../components/applications/eCommerce/invoices/invoice1";

const Invoice1 = () => {
  return <Invoice1Container />;
};

export default Invoice1;
